import * as THREE from "three";
import {
  Box3Helper,
  BoxHelper,
  BufferGeometry,
  Line,
  LineSegments,
  Mesh,
  Sprite,
} from "three";
import { Context } from "./context";
import { DbBlockInstance } from "./DbBlockInstance";
import { DBEntity } from "./DBEntity";
import { DbLine } from "./DbLine";
import { DbMesh } from "./DbMesh";
import { IndserObject } from "./IndserObject";
import { CommonColor, SelectionState } from "./Parameters";
import * as BufferGeometryUtils from "three/examples/jsm/utils/BufferGeometryUtils";

/**
 * 拾取，选择管理数据集合
 */
export class SelectionData extends THREE.Object3D {
  m_hightColor: THREE.Color = new THREE.Color(CommonColor.Pick); //0x4ADDEC
  public m_hightMaterial: THREE.LineBasicMaterial;
  public m_hightMeshMaterial: THREE.MeshBasicMaterial;
  private m_meshs: DbMesh[] = [];
  private m_lines: DbLine[] = [];
  private m_instances: DbBlockInstance[] = [];
  public m_threeObjects: THREE.Object3D[] = [];
  private m_context: Context;
  public MAX = 10000;
  constructor(
    context: Context,
    color: THREE.Color = new THREE.Color(CommonColor.Pick)
  ) {
    super();
    this.m_hightColor = color;
    this.m_hightMaterial = new THREE.LineBasicMaterial({
      color: this.m_hightColor,
      side: THREE.DoubleSide,
      transparent: true,
      // depthTest: false,
      // depthWrite: false,
    });
    this.m_hightMeshMaterial = new THREE.MeshBasicMaterial({
      color: this.m_hightColor,
      side: THREE.DoubleSide,
      transparent: true,
      // depthTest: false,
      // depthWrite: false,
    });
    this.m_context = context;
    this.m_context.SceneManager.AuxModel.add(this);
  }

  public setColor(color: number, opacity: number) {
    this.m_hightMaterial.color = new THREE.Color(color);
    this.m_hightMeshMaterial.color = new THREE.Color(color);
    this.m_hightMaterial.opacity = opacity;
    this.m_hightMeshMaterial.opacity = opacity;
  }

  private m_startIndex = 0;
  public addObjects(
    entities: (DBEntity | THREE.Object3D)[],
    isMultipleChoice: boolean = false
  ) {
    let temp: Map<string, DbLine | DbMesh> = new Map();
    let temp1: Map<any, any> = new Map();
    let noRootIdEntities: any[] = [];
    let lineAttributeSum: THREE.BufferAttribute[] = [];
    let meshAttributeSum: THREE.BufferAttribute[] = [];
    let lineIndexesSum: number[] = [];
    entities.forEach((entity) => {
      if (entity instanceof DbLine || entity instanceof DbMesh) {
        if (entity.root_reference_id) {
          temp.set(entity.root_reference_id, entity);
        } else {
          temp1.set(entity, entity);
        }
      } else {
        temp1.set(entity, entity);
      }
    });
    this.m_startIndex = 0;
    for (let i = 0; i < entities.length; i++) {
      let entity = entities[i];
      if (noRootIdEntities.includes(entity)) {
        continue;
      }
      this.addObject(
        entity,
        lineAttributeSum,
        lineIndexesSum,
        meshAttributeSum
      );
    }
    if (lineAttributeSum?.length) {
      let lineGeo = new THREE.BufferGeometry();
      let mergeAttribute =
        BufferGeometryUtils.mergeBufferAttributes(lineAttributeSum);

      lineGeo.setAttribute(
        "position",
        new THREE.BufferAttribute(mergeAttribute.array, 3)
      );
      lineGeo.setIndex(lineIndexesSum);
      let line = new THREE.LineSegments(lineGeo, this.m_hightMaterial);
      this.add(line);
    }
    if (meshAttributeSum?.length) {
      let meshGeo = new THREE.BufferGeometry();
      let mergeAttribute =
        BufferGeometryUtils.mergeBufferAttributes(meshAttributeSum);
      meshGeo.setAttribute(
        "position",
        new THREE.BufferAttribute(mergeAttribute.array, 3)
      );
      let mesh = new THREE.Mesh(meshGeo, this.m_hightMeshMaterial);
      this.add(mesh);
    }
    let rootLineAttributeSum: THREE.BufferAttribute[] = [];
    let rootLineIndexesSum: number[] = [];
    let rootLineStartIndex = 0;
    let rootMeshAttributeSum: THREE.BufferAttribute[] = [];

    for (let [key, item] of temp) {
      let value = this.m_context.ModelManager.Group[key];
      {
        if (value?.lineGeo) {
          // 框选时合并顶点
          if (
            this.m_context.SelectionManager.SelectionState ==
            SelectionState.SelectionBox
          ) {
            rootLineAttributeSum.push(
              value.lineGeo.attributes
                .position as unknown as THREE.BufferAttribute
            );

            let indexes = value.lineGeo.index?.array as number[];
            if (indexes && indexes.length) {
              indexes = Array.from(indexes);
              indexes.forEach((v) => {
                rootLineIndexesSum.push(v + rootLineStartIndex);
              });
            }
            rootLineStartIndex += value.lineGeo.attributes.position.count;
          } else {
            let line = new THREE.LineSegments(
              value.lineGeo,
              this.m_hightMaterial
            );
            line.userData.root_reference_id = key;
            line.userData.obj = line;
            this.add(line);
          }
        }
      }
      {
        if (value?.meshGeo) {
          if (
            this.m_context.SelectionManager.SelectionState ==
            SelectionState.SelectionBox
          ) {
            rootMeshAttributeSum.push(
              value.meshGeo.attributes
                .position as unknown as THREE.BufferAttribute
            );
          } else {
            let mesh = new THREE.Mesh(value.meshGeo, this.m_hightMeshMaterial);
            mesh.userData.root_reference_id = key;
            mesh.userData.obj = mesh;
            this.add(mesh);
          }
        }
      }
    }

    if (rootLineAttributeSum.length) {
      let lineGeo = new THREE.BufferGeometry();
      let lineAttribute =
        BufferGeometryUtils.mergeBufferAttributes(rootLineAttributeSum);
      lineGeo.setAttribute(
        "position",
        new THREE.BufferAttribute(lineAttribute.array, 3)
      );
      lineGeo.setIndex(rootLineIndexesSum);
      let line = new THREE.LineSegments(lineGeo, this.m_hightMaterial);
      this.add(line);
    }
    if (rootMeshAttributeSum.length) {
      let meshGeo = new THREE.BufferGeometry();
      let meshAttribute =
        BufferGeometryUtils.mergeBufferAttributes(rootMeshAttributeSum);
      meshGeo.setAttribute(
        "position",
        new THREE.BufferAttribute(meshAttribute.array, 3)
      );
      let mesh = new THREE.Mesh(meshGeo, this.m_hightMeshMaterial);
      this.add(mesh);
    }
  }

  /**
   *
   * @param obj 添加拾取元素
   */
  private addObject(
    obj: DBEntity | THREE.Object3D,
    lineAttributeSum: THREE.BufferAttribute[],
    lineIndexesSum: number[],
    meshAttributeSum: THREE.BufferAttribute[]
  ): DbLine | DbMesh | undefined {
    if (obj instanceof DbLine) {
      this.m_lines.push(obj);
      if (obj.root_reference_id) return obj;
      let attribute = new THREE.BufferAttribute(
        new Float32Array(obj.points),
        3
      );

      obj.indexes?.forEach((v) => {
        lineIndexesSum.push(v + this.m_startIndex);
      });
      this.m_startIndex += obj.points.length / 3;
      lineAttributeSum.push(attribute);
      // let geo = new THREE.BufferGeometry();
      // geo.setAttribute("position", new THREE.BufferAttribute(obj.points, 3));
      // geo.setIndex(new THREE.Uint32BufferAttribute(obj.indexes, 1));
      // let line = new LineSegments(geo, this.m_hightMaterial);
      // line.renderOrder = 10;
      // line.userData.obj = obj;
      // this.add(line);
    }
    if (obj instanceof DbMesh) {
      this.m_meshs.push(obj);
      if (obj.root_reference_id) return obj;
      //to-do mesh高亮无效
      // let geo = new THREE.BufferGeometry();
      // let arr: number[] = [];
      // for (let index = 0; index < obj.vertexs.length; index++) {
      //   const element = obj.vertexs.at(index);
      //   if (element != undefined) arr.push(element);
      // }
      // geo.setAttribute("position", new THREE.Float32BufferAttribute(arr, 3));
      // let mesh = new Mesh(geo, this.m_hightMeshMaterial);
      // mesh.renderOrder = 10;
      // mesh.position.x = 0;
      // mesh.userData.obj = obj;
      // this.add(mesh);
      let attribute = new THREE.BufferAttribute(
        new Float32Array(obj.vertexs),
        3
      );
      meshAttributeSum.push(attribute);
    }
    if (obj instanceof DbBlockInstance) {
      this.m_instances.push(obj);
      let block = obj.blockRecord;
      let lineGeo = new THREE.BufferGeometry();
      let posistion: number[] = [];
      let index = 0;
      let indexs: number[] = [];
      block.lines.array.forEach((item) => {
        posistion.push(...(item.points || []));
        item.indexes?.forEach((v) => {
          indexs.push(v + index);
        });
        index += item.points.length / 3;
      });
      lineGeo.setAttribute(
        "position",
        new THREE.BufferAttribute(new Float32Array(posistion), 3)
      );
      lineGeo.setIndex(indexs);
      let lineMesh = new THREE.LineSegments(lineGeo, this.m_hightMaterial);
      lineMesh.matrix.copy(obj.matrix);
      lineMesh.userData.obj = obj;
      this.add(lineMesh);

      posistion.length = 0;
      block.meshs.array.forEach((geo) => {
        geo.vertexs?.forEach((v) => {
          posistion.push(v);
        });
      });
      let geometry = new THREE.BufferGeometry();
      geometry.setAttribute(
        "position",
        new THREE.BufferAttribute(new Float32Array(posistion), 3)
      );
      let mesh = new Mesh(geometry, this.m_hightMeshMaterial);
      this.add(mesh);
    }
    if (obj instanceof THREE.Object3D) {
      this.m_threeObjects.push(obj);
      let { PolygonDatas } = this.m_context.ViewManager;
      if (obj instanceof THREE.Mesh) {
        let id = obj.userData.id;
        if (PolygonDatas.has(obj.userData.id)) {
          let geometry = new BufferGeometry();
          geometry.copy((obj as THREE.Mesh).geometry);
          let mesh = new Mesh(geometry, this.m_hightMeshMaterial);
          // mesh.position.z=-1
          mesh.userData.obj = obj;
          this.add(mesh);
          // meshAttributeSum.push(obj.geometry.attributes.position);
        }
      }
      if (obj instanceof THREE.Sprite) {
        let box = new BoxHelper(obj, this.m_hightColor);
        box.userData.obj = obj;
        this.add(box);
      }
    }
  }

  /**
   *
   * @returns 获取拾取元素
   */
  public getObjects(): (DBEntity | THREE.Object3D)[] {
    let entities: (DBEntity | THREE.Object3D)[] = [];
    this.m_lines.forEach((line) => {
      entities.push(line);
    });
    this.m_meshs.forEach((mesh) => {
      entities.push(mesh);
    });
    this.m_instances.forEach((instacnce) => {
      entities.push(instacnce);
    });
    this.m_threeObjects.forEach((instacnce) => {
      entities.push(instacnce);
    });
    return entities;
  }

  /**
   *
   * @returns 清空拾取
   */
  public clear(): this {
    this.m_lines.length = 0;
    this.m_meshs.length = 0;
    this.m_threeObjects.length = 0;
    this.m_instances.length = 0;
    this.children.forEach((item) => {
      let mesh = item as Mesh;
      mesh.geometry.dispose();
      let line = item as Line;
      line.geometry.dispose();
    });
    super.clear();
    return this;
  }

  public Remove(obj: THREE.Object3D | DBEntity): boolean {
    for (let i = 0; i < this.children.length; i++) {
      if (this.children[i].userData.obj == obj) {
        if (
          obj instanceof THREE.LineSegments ||
          obj instanceof THREE.Mesh ||
          obj instanceof THREE.Line
        ) {
          obj?.geometry?.dispose();
          obj?.material?.dispose();
        }
        this.children.splice(i, 1);
        return true;
      }
    }
    return false;
  }
  /**
   * 按shift多选时如果把高亮的元素再点一次就取消点击的高亮元素
   * */
  public clearObj(obj: THREE.Object3D | DBEntity): boolean {
    let points!: Float32Array[] | Float32Array;
    if (obj instanceof DbLine) {
      points = obj.points;
      if (obj.root_reference_id) {
        let arrLines: any = [];
        let arrLinesSum: any = [];
        let arrMeshs: any = [];
        let arrMeshsSum: any = [];

        this.m_context.ModelManager.Group[obj.root_reference_id].lines.forEach(
          (item) => {
            item.points.forEach((p, i) => {
              if (arrLines.length >= this.MAX - 1) {
                arrLines.push(p);
                arrLinesSum.push(arrLines.slice());
                arrLines.length = 0;
              } else {
                arrLines.push(p);
                if (i == item.points.length - 1) {
                  arrLinesSum.push(arrLines.slice());
                  arrLines.length = 0;
                }
              }
            });
          }
        );
        this.m_context.ModelManager.Group[obj.root_reference_id].mesh.forEach(
          (item) => {
            item.vertexs.forEach((p, i) => {
              if (arrMeshs.length >= this.MAX - 1) {
                arrMeshs.push(p);
                arrMeshsSum.push(arrMeshs.slice());
                arrMeshs.length = 0;
              } else {
                arrMeshs.push(p);
                if (i == item.vertexs.length - 1) {
                  arrMeshsSum.push(arrMeshs.slice());
                  arrMeshs.length = 0;
                }
              }
            });
          }
        );

        points = [arrLinesSum.flat(), arrMeshsSum.flat()];
      }
      let index = this.m_lines.indexOf(obj);
      if (index > -1) {
        this.m_lines.splice(index, 1);
      }
    }
    if (obj instanceof DbMesh) {
      points = obj.vertexs;
      if (obj.root_reference_id) {
        let arrLines: any = [];
        let arrLinesSum: any = [];
        let arrMeshs: any = [];
        let arrMeshsSum: any = [];

        this.m_context.ModelManager.Group[obj.root_reference_id].lines.forEach(
          (item) => {
            item.points.forEach((p, i) => {
              if (arrLines.length >= this.MAX - 1) {
                arrLines.push(p);
                arrLinesSum.push(arrLines.slice());
                arrLines.length = 0;
              } else {
                arrLines.push(p);
                if (i == item.points.length - 1) {
                  arrLinesSum.push(arrLines.slice());
                  arrLines.length = 0;
                }
              }
            });
          }
        );
        this.m_context.ModelManager.Group[obj.root_reference_id].mesh.forEach(
          (item) => {
            item.vertexs.forEach((p, i) => {
              if (arrMeshs.length >= this.MAX - 1) {
                arrMeshs.push(p);
                arrMeshsSum.push(arrMeshs.slice());
                arrMeshs.length = 0;
              } else {
                arrMeshs.push(p);
                if (i == item.vertexs.length - 1) {
                  arrMeshsSum.push(arrMeshs.slice());
                  arrMeshs.length = 0;
                }
              }
            });
          }
        );

        points = [arrLinesSum.flat(), arrMeshsSum.flat()];
      }
      let index = this.m_meshs.indexOf(obj);
      if (index > -1) {
        this.m_meshs.splice(index, 1);
      }
    }
    if (obj instanceof THREE.Object3D) {
      if (this.m_threeObjects.length > 0) {
        let index: number;
        index = this.m_threeObjects.indexOf(obj);
        //@ts-ignore
        points = obj.geometry.attributes.position.array;
        if (index > -1) {
          this.m_threeObjects.splice(index, 1);
        }
      }
    }

    for (let i = 0; i < this.children.length; i++) {
      if (
        this.children[i] instanceof THREE.Mesh ||
        this.children[i] instanceof THREE.Line ||
        this.children[i] instanceof THREE.LineSegments ||
        this.children[i] instanceof THREE.Sprite
      ) {
        let vts =
          //@ts-ignore
          this.children[i].geometry.attributes.position.array.toString();
        //@ts-ignore
        let pts = "";
        if (obj instanceof DbLine || obj instanceof DbMesh) {
          if (obj.root_reference_id) {
            if (Array.isArray(points)) {
              for (let j = 0; j < points.length; j++) {
                pts = points[j].toString();
                if (vts == pts) {
                  this.children.splice(i, 1);
                  points.splice(j, 1);
                  j--;
                  i--;
                  if (!points.length) {
                    return true;
                  }
                }
              }
            }
          } else {
            pts = points?.toString();
            if (vts == pts) {
              this.children.splice(i, 1);
              return true;
            }
          }
        } else {
          pts = points?.toString();
          if (vts == pts) {
            this.children.splice(i, 1);
            return true;
          }
        }
      }
    }

    return false;
  }
}
